import { del } from "../../utils/axios-config";
import { ROLES } from "../../utils/constants";

export const removeRole = async (roleId: string) => {
    const url = `${ROLES}/${roleId}`;
    return await del<string, string>(url, roleId);
};